<template>
  <div>
    <div v-if="!loading">

      <!-- Data Table -->
      <Table
        v-if="notifications.length > 0"
        :headers="headers"
        :cols="cols"
        :data="notifications"
        :model="model"
        :checkbox="false"
        :notselect="true"
        :fieldsLoading="notificationLoading"
          >
      </Table>

      <!-- Pagination -->
      <div v-if="notifications.length > 0" class="row">
        <div class="col">
          <div class="float-left">
            <Pagination
              :total="total"
              :totalpage="notificationsQty"
              :model="model"
              :limit="true"
              :color="'primary'"
              @changePage="changePage"
              key="paginationkey"
            ></Pagination>
          </div>
        </div>
      </div>

      <!-- No data -->
      <div v-else class="text-center">
         {{ $t('lang.label.noresultsfound') }}
      </div>
    </div>

    <!-- Loading -->
    <div v-else>
      <LoadingSpinner />
    </div>

  </div>

</template>

<script>

import { notificationService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";

export default {
  name: 'ListNotifications',
  components: { Table, Pagination, LoadingSpinner },
  props: {
    clientId: {
      type: Number,
      required: true
    },
  },

  data() {
    return {
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      loading: false,
      total: 0,
      captainkey: 322,
      notificationLoading: false,
      headers:[
        {
          label: this.$t('lang.column.date'),
          percentage: "10%",
          class: "overflowhide",
          id: 1,
        },
        {
          label: this.$t('lang.label.hour'),
          percentage: "10%",
          class: "overflowhide",
          id: 2,
        },
        {
          label: this.$t('lang.notification.notification_type'),
          percentage: "80%",
          class: "overflowhide",
          id: 3,
        },
      ],
      cols:[
        [
          {
          value: "date",
          }
        ],
        [
          {
          value: "hour",
          }
        ],
        [
          {
          value: "name",
          }
        ],

      ],
      notifications: [],
      notificationStatus: 10,
    };
  },

  mounted() {
    this.getNotifications();
  },
  computed: {
    notificationsQty(){
      return this.notifications.length
    }
  },

  methods: {
    getNotifications(notification){

      if (this.notificationStatus != notification) {
        this.model.currentPage = 1;
      }

      const filterParams = {
        currentPage: this.model.currentPage,
        cantPerPage: this.model.cantPerPage,
        filters: { notificationTypeIds: [8, 9, 12, 13, 14, 15, 16, 17, 18, 19] },
      };

      const data = { client_id: this.clientId, filterParams: filterParams };

      this.loading = true;
      notificationService.getNotificationsByClient(data)
        .then(response => {
           if( response ){
            const { notifications, total } = response.result
            this.notifications = notifications.map( item =>  {
              item.date = moment(String(item.date)).format('MM/DD/YYYY')
              return item;
            })
            this.total = Number(total);
          } else {
            this.notifications = []
            this.total = 0;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err.result)
        });
    },
    changePage() {
      this.getNotifications(this.notificationStatus);
    },
  },
};
</script>
